import { useEffect } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Layout } from "@components/Layout/index";
import { getAllDocumentsByType, getStore, getModalSettings, getGlobalConfig } from "@lib/api/calls";
import { Render } from "@components/sections";
import { StoreCard } from "@components/Store/StoreCard";
import { trackEvent } from "@lib/track-event";
import { resolveStorefrontName } from "@lib/resolve-store-front-name";
import { Banner } from "@components/Banner";
import styles from "./Stores.module.css";

export default function Store({ preview, title, seo, store, config, subscribed, modal }) {
  useEffect(() => {
    trackEvent("view_page", {
      pageTitle: title,
      pageCategory: "Information Page",
      pageLocation: window.location.href,
      pagePath: window.location.pathname,
    });
  }, []);
  return (
    <Layout
      config={config}
      title={title}
      seo={seo}
      subscribed={subscribed}
      isPreview={preview}
      pageFound={store !== null}
      modal={modal}
    >
      <Banner title={title} image={seo?.openGraphImage} altText={resolveStorefrontName(store)} />

      {store && <StoreCard store={store} />}

      <hr className={styles.divider} />

      {store?.blocks && <Render sections={store.blocks} />}
    </Layout>
  );
}

export async function getStaticPaths() {
  // Return a list of possible value for id
  const allStores = await getAllDocumentsByType("store");
  const paths = allStores?.map((store) => ({
    params: {
      slug: store.slug,
    },
  }));
  return {
    paths,
    fallback: true,
  };
}

export async function getStaticProps({ params, preview = false, locale }) {
  const modal = await getModalSettings(locale, preview);
  const config = await getGlobalConfig(locale, preview);
  const storePage = params?.slug ? await getStore(params.slug, locale, preview) : null;

  const seo = {
    seoTitle: storePage?.meta?.seoTitle || `${storePage?.title} | Kotn`,
    seoDescription: storePage?.meta?.seoDescription || "",
    openGraphImage: storePage?.meta?.openGraphImage || null,
    twitterCard: storePage?.meta?.seoTwitterCardStyle || "summary_large_image",
  };

  return {
    props: {
      preview,
      title: storePage?.title || "Store Locator",
      seo,
      store: storePage,
      modal,
      config,
      ...(await serverSideTranslations(locale, ["common", "navbar", "footer", "store", "cart"])),
    },
    revalidate: 1800,
  };
}
